import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api_middleware";

export const fetchUser = createAsyncThunk(
  "base/fetchUser",
  async () => {
    const response = await api("v1/admin/user", "GET");
    return response;
  }
);